import React from "react";
import { Table } from "react-bootstrap";
import type { AdsAuditLog, AdsAuditLogChange } from "../../../../api/ads";

import "./AdsAuditLogTable.css";

export interface AdsAuditLogTableProps {
  logs: AdsAuditLog[];
}

const formatTimestamp = (iso: string) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
};

const formatValue = (val: any): string => {
  if (val === null || val === undefined) return "—";
  if (typeof val === "boolean") return val ? "true" : "false";
  return String(val);
};

const renderChanges = (changes: AdsAuditLogChange[]) => {
  if (!changes.length) return <span className="audit-table__no-changes">—</span>;
  return (
    <ul className="audit-table__changes-list">
      {changes.map((c, i) => (
        <li key={i}>
          <span className="audit-table__field">{c.field}:</span>{" "}
          <span className="audit-table__old-val">{formatValue(c.old_value)}</span>
          {" → "}
          <span className="audit-table__new-val">{formatValue(c.new_value)}</span>
        </li>
      ))}
    </ul>
  );
};

export const AdsAuditLogTable: React.FC<AdsAuditLogTableProps> = ({ logs }) => {
  return (
    <div className="audit-table-wrapper">
      <Table responsive className="audit-table">
        <thead>
          <tr>
            <th>Actor</th>
            <th>Action</th>
            <th>Entity</th>
            <th>Changes</th>
            <th className="audit-table__timestamp-col">Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((l) => (
            <tr key={l.id}>
              <td className="audit-table__actor">
                <div>{l.changedBy.fullName}</div>
                <div className="audit-table__actor-email">{l.changedBy.email}</div>
              </td>
              <td className="audit-table__action">{l.action}</td>
              <td>
                <div>{l.entityType}</div>
                <div className="audit-table__entity-id">{l.entityId}</div>
              </td>
              <td className="audit-table__diff">{renderChanges(l.changes)}</td>
              <td className="audit-table__timestamp">{formatTimestamp(l.timestamp)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
